import React from 'react';
import './App.css';
import './css/bootstrap.min.css';
import './fontawesome';
import Page from "./components/Page";

class App extends React.Component {
  render() {
    return (
      <Page />
    );
  }
}

export default App;
